var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: ".9rem",
    height: ".9rem",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m19.873 9.687-8.647-8.583c-.24-.237-.607-.042-.607.32V6.46c0 .225-.153.414-.349.423-5.005.207-9.214 4.391-10.1 10.13l-.164 1.065c-.065.414.378.672.63.366l.647-.786c2.336-2.847 5.58-4.446 8.97-4.43.202 0 .369.188.369.422v4.926c0 .363.37.558.607.321l8.646-8.568a.472.472 0 0 0-.002-.641zM2.085 14.834c1.458-3.867 4.781-6.47 8.579-6.47h.885c.203 0 .367-.19.367-.423V3.76l6.29 6.246-6.29 6.231v-4.074c0-.234-.164-.423-.367-.423h-.805c-3.133-.144-6.185.966-8.66 3.093z"
  })));
};
export default SvgShare;